import format from 'date-fns/format';
import { config } from '@uhg-abyss/web/tools/config';
import pdfLogo from '@src/app/App/Content/Confirmation/print/pdf_logo.png';

let html2pdf;
if (typeof window !== 'undefined') {
  html2pdf = require('html2pdf.js');
}

const createHeader = () => {
  const date = document.createElement('div');
  date.textContent = format(new Date(), 'MM/dd/yyyy');
  date.setAttribute(
    'style',
    'color:#002677;font-size:18px;font-weight:bold;margin-top:3px;margin-right:7px'
  );
  const title = document.createElement('div');
  title.textContent = 'Tin Registration Status';
  title.setAttribute(
    'style',
    'text-align:center;width:100%;color:#002677;font-size:20px;font-weight:bold;margin-top:3px;margin-left:135px'
  );

  const header = document.createElement('div');
  header.setAttribute(
    'style',
    'display:flex;font-size:10px;margin-bottom:65px'
  );
  header.appendChild(title);
  header.appendChild(date);

  return header;
};

export const print = {
  printPage: () => {
    if (typeof window !== 'undefined') {
      window.print();
    }
  },
  savePDF: (element, fileName, callback) => {
    if (!html2pdf) {
      if (callback) callback();
      return; // SSR guard
    }

    const header = createHeader();
    const pdfWrapper = document.createElement('div');
    pdfWrapper.setAttribute('style', 'margin:0 10px');
    pdfWrapper.appendChild(header);
    const tinStatus = document.getElementById('print-status');

    if (!tinStatus) {
      if (callback) callback();
      return;
    }

    if (tinStatus) {
      pdfWrapper.appendChild(tinStatus.cloneNode(true));
    }

    const styleElement = document.createElement('style');
    styleElement.textContent = `
      * {
        box-shadow: none !important;
      }
      [class*="header"], [class*="Header"], header, .abyss-card-title, [class*="abyss-card-title"], h3 {
        background-color: #E5E5E6 !important;
        padding: 10px !important;
        color: #323334;
      }
      [class*="abyss-card-section"] {
        padding: 12px 24px 12px 24px !important;
      }
      [class*="abyss-card-root"] {
        border-color: #d1d5db !important;
      }
      button {
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: clip !important;
        word-wrap: break-word !important;
      }
      [id*="downloadButton"] {
        width: auto !important;
        min-width: fit-content !important;
      }
    `;
    pdfWrapper.insertBefore(styleElement, pdfWrapper.firstChild);

    const opt = {
      margin: [2, 0],
      filename: `${fileName}.pdf`,
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      html2canvas: {
        onclone: (el) => {
          const svgElements = Array.from(el.querySelectorAll('svg'));
          svgElements.forEach((s) => {
            const bBox = s.getBoundingClientRect();
            s.setAttribute('x', bBox.x);
            s.setAttribute('y', bBox.y);
            s.setAttribute('width', bBox.width);
            s.setAttribute('height', bBox.height);
          });
        },
      },
    };

    html2pdf()
      .from(pdfWrapper)
      .set(opt)
      .toPdf()
      .get('pdf')
      .then(async (pdf) => {
        pdf.setPage(1);
        try {
          // Get the correct image source
          const imgSrc =
            typeof pdfLogo === 'string'
              ? pdfLogo
              : pdfLogo?.src || pdfLogo?.default;

          if (imgSrc) {
            // Fetch image and convert to data URL to avoid CORS issues
            let response;
            if (config('APP_ENV') === 'local') {
              response = await fetch(imgSrc);
            } else {
              response = await fetch(`${config('PUBLIC_IMAGE')}${imgSrc}`);
            }

            const blob = await response.blob();
            const dataUrl = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                return resolve(reader.result);
              };
              reader.readAsDataURL(blob);
            });
            pdf.addImage(dataUrl, 'PNG', 3, 4, 54, 17);
          }
        } catch (error) {
          console.error('Error adding logo to PDF:', error);
        }
        return pdf;
      })
      .save()
      .then(() => {
        if (callback) callback();
      })
      .catch((error) => {
        if (callback) callback();
      });
  },
};
